import React, { useEffect, useMemo, useState } from 'react';
import { useCart } from '../../contexts/CartProvider';
import styles from './style.module.scss';
import { Button, Input, Divider, Checkbox } from 'antd';
import { FaTag } from 'react-icons/fa6';
import { HiOutlineShieldCheck } from 'react-icons/hi';
import { MdAccountBalanceWallet } from 'react-icons/md';
import { api } from '../../services/apiClient';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSaldo } from '../../contexts/SaldoContext';

const CreditoPrePago = ({ items, handleNextStep, couponCode, setCouponCode, validarCupon }) => {
  const { clearCart, coupon } = useCart();
  const { fetchSaldo, saldo } = useSaldo();
  const navigate = useNavigate();

  const [isSaldoRoute, setIsSaldoRoute] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cupomAplicado, setCupomAplicado] = useState(false);
  const [aceiteTermos, setAceiteTermos] = useState(false);

  useEffect(() => {
    setIsSaldoRoute(window.location.href.includes('/saldo'));
  }, []);

  const formatCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);

  const totals = useMemo(() => items.reduce((acc, item) => {
    if (!acc[item.nome]) acc[item.nome] = 0;
    acc[item.nome] += item.quantidade * item.valor;
    return acc;
  }, {}), [items]);

  const initialGrandTotal = useMemo(() => Object.values(totals).reduce((acc, value) => acc + value, 0), [totals]);
  const totalQuantidade = useMemo(() => items.reduce((acc, item) => acc + item.quantidade, 0), [items]);

  let grandTotal = initialGrandTotal;
  let grandTotalBeforeDiscount = initialGrandTotal;
  let desconto = 0;
  if (coupon && coupon.isValid) {
    if (coupon.is_porcentagem === 1) {
      desconto = initialGrandTotal * (coupon.discount / 100);
      grandTotal -= desconto;
    } else {
      desconto = coupon.discount;
      grandTotal -= desconto;
    }
  }

  const handleCupon = async () => {
    if (!couponCode?.trim()) {
      toast.warn('Digite um cupom para aplicar.');
      return;
    }

    const validar = await validarCupon(couponCode);
    if (validar) {
      setCupomAplicado(true);
      toast.success('Cupom aplicado com sucesso!');
      return;
    }

    toast.error('Cupom inválido.');
  };

  const handlePayCard = async () => {
    setLoading(true);
    if (!aceiteTermos) {
      toast.warn('Por favor aceite os termos de uso e a política de privacidade', { position: 'top-right', autoClose: 5000, theme: 'dark' });
      setLoading(false);
      return;
    }

    try {
      const responsePayment = await api.post('/pagamento_com_saldo', {
        boloes: items,
        quantity: totalQuantidade,
        total_desconto: grandTotal,
        cupom_desconto_id: coupon?.id,
        total: grandTotalBeforeDiscount,
      });

      fetchSaldo();

      if (responsePayment.status === 200 && responsePayment.data.status === 'approved' && responsePayment.data.status_info === 'pago totalmente') {
        clearCart();
        toast.success('Compra feita com sucesso', { position: 'top-right', autoClose: 5000, theme: 'light' });
        handleNextStep('saldo');
        window.scrollTo(0, 0);
        navigate('/minha-conta');
      }
    } catch (e) {
      console.log('e', e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.checkoutPage}>
      <div className={styles.grid}>
        <section className={styles.leftColumn}>
          {!isSaldoRoute && (
            <div className={styles.cardBox}>
              <div className={styles.sectionTitle}><FaTag /><h2>Você tem algum cupom de desconto?</h2></div>
              <p className={styles.sectionDescription}>Digite abaixo para aplicar no pagamento com saldo.</p>
              <div className={styles.couponRow}>
                <Input placeholder='Digite seu cupom' value={couponCode} onChange={(e) => setCouponCode(e.target.value)} disabled={cupomAplicado} />
              </div>
                <Button className={styles.applyButton} onClick={handleCupon} disabled={cupomAplicado}>{cupomAplicado ? 'Aplicado' : 'Aplicar cupom'}</Button>
            </div>
          )}

          <div className={styles.cardBox}>
            <div className={styles.sectionTitle}><MdAccountBalanceWallet /><h2>Pagamento com saldo</h2></div>
            <p className={styles.sectionDescription}>Seu saldo atual será usado para concluir este pedido.</p>
            <div className={styles.balanceHighlight}>Saldo disponível: <strong>{formatCurrency(saldo)}</strong></div>
          </div>

          <div className={styles.securityBox}>
            <HiOutlineShieldCheck />
            <div>
              <strong>Compra segura</strong>
              <p>Validação protegida e confirmação imediata após aprovação.</p>
            </div>
          </div>

          <div className={styles.termsRow}>
            <Checkbox checked={aceiteTermos} onChange={(e) => setAceiteTermos(e.target.checked)}>
              Li e concordo com os <strong>Termos de Uso</strong> e <strong>Política de Privacidade</strong>
            </Checkbox>
          </div>
        </section>

        <aside className={styles.rightColumn}>
          <div className={styles.summaryCard}>
            <h2>Resumo do pedido</h2>
            <div className={styles.summaryItems}>
              {Object.keys(totals).map((nome) => (
                <div key={nome} className={styles.summaryRow}><span>{nome}</span><strong>{formatCurrency(totals[nome])}</strong></div>
              ))}
              {coupon && coupon.isValid && (
                <div className={`${styles.summaryRow} ${styles.discountRow}`}><span>Cupom ({couponCode})</span><strong>-{formatCurrency(desconto)}</strong></div>
              )}
            </div>
            <Divider className={styles.divider} />
            <div className={styles.totalRow}><span>Total</span><h3>{formatCurrency(grandTotal)}</h3></div>
            <Button loading={loading} disabled={loading} className={styles.confirmButton} onClick={handlePayCard} block>Confirmar compra</Button>
            <p className={styles.warningText}>Após finalizar a compra, não será possível estorno automático.</p>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default CreditoPrePago;
